import { useId, useState } from 'react';

export default function ArtistSpecialisations({ value = '', profession = '' }) {
  const [expanded, setExpanded] = useState(false);
  const id = useId();
  const seen = new Set([String(profession || '').trim().toLowerCase(), 'null', 'undefined']);
  const items = String(value || '').split(',').map((item) => item.trim()).filter((item) => {
    const key = item.toLowerCase();
    if (!item || seen.has(key)) return false;
    seen.add(key);
    return true;
  });
  if (!items.length) return null;
  return <div className="mb-4 min-w-0 text-left">
    <ul id={id} aria-label="Artist specialisations" className="flex flex-wrap justify-center gap-2 md:justify-start">
      {items.map((item, index) => <li key={item} hidden={!expanded && index >= 6}
        className={`${!expanded && index >= 6 ? 'hidden' : 'inline-flex'} max-w-full rounded-lg border border-slate-200 bg-slate-50 px-2.5 py-1 text-sm leading-5 text-slate-700 [overflow-wrap:anywhere]`}>{item}</li>)}
    </ul>
    {items.length > 6 && <button type="button" aria-expanded={expanded} aria-controls={id}
      onClick={() => setExpanded((current) => !current)}
      className="mt-2 rounded px-1 py-1 text-sm font-semibold text-orange-700 underline underline-offset-4 focus-visible:outline focus-visible:outline-2 focus-visible:outline-orange-600">
      {expanded ? 'Show fewer' : `Show all ${items.length} specialisations (+${items.length - 6})`}
    </button>}
  </div>;
}
